export default "__VITE_ASSET__DALRbUWc__"